export default __webpack_public_path__ + "static/media/DownloadReport.f287aaf5.svg";